<template>
  <li>
    <div class="thumb-wrapper" v-if="post.thumbnail">
      <a :href="post.permalink" v-html="post.thumbnail"></a>
    </div>
    <div class="description-wrapper">
      <a :href="post.permalink" class="news-list-title">{{post.post_title}}</a>
      <div class="news-date">{{post.post_date}} {{post.location ? '| '+post.location : ''}}</div>
      <div class="news-excerpt" v-html="post.excerpt"></div>
      <a :href="post.permalink" class="news-readmore">Read more <i class="arrow-right-blue"></i></a>
    </div>
  </li>

</template>

<script>
  export default {
    name: "PostItem",
    props: ['post'],
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/article/ArticleItem.vue